<template>
  <div id="app" class="font-sans antialiased flex flex-col">
    <router-view :key="JSON.stringify($route.params)" v-if="!loading" />
    <Loading v-else class="h-screen" />
  </div>
</template>

<script>
import teamsClient from '@/api/central/teams';
import Loading from '@/components/Loading';

export default {
  components: { Loading },
  data() {
    return {
      loading: true,
    };
  },

  mounted() {
    this.initAuthentication().then(() => {
      this.ensureTeamMembership().then(() => (this.loading = false));
    });
  },

  methods: {
    ensureTeamMembership() {
      return teamsClient.index().then(async ({ data }) => {
        let defaultOrNewTeamId = this.needsOnboarding(data.data.teams)
          ? (await teamsClient.store()).data.data.id
          : data.data.defaultTeam.id;

        return !this.isTeamMember(data.data.teams) && this.pushToTeam(defaultOrNewTeamId);
      });
    },

    initAuthentication() {
      return this.$store.dispatch('authentication/init');
    },

    needsOnboarding(teams) {
      return teams.length == 0;
    },

    isTeamMember(teams) {
      let admins = [
        'bengt@localticketing.de',
        'marc@localticketing.de',
        'valerie@localticketing.de',
      ];

      if (admins.includes(this.$store.state.authentication.keycloak.idTokenParsed.email)) {
        return true;
      }

      return teams.filter((el) => el.id == this.$route.params.organizer).length > 0;
    },

    pushToTeam(id) {
      this.$router.push({
        name: 'dashboard',
        params: { organizer: id },
      });
    },
  },
};
</script>
